import React, { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { useI18n } from "../i18n/I18nContext";

export default function LangLayout() {
  const { lang } = useParams();
  const { setLang } = useI18n();

  useEffect(() => {
    if (lang === "ar" || lang === "en") {
      setLang(lang);
      document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
    }
  }, [lang, setLang]);

  if (lang !== "ar" && lang !== "en") {
    return <Navigate to="/ar" replace />;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
